<template lang="pug">
FetchErrorTransition(
  :isFetching="isFetching"
  :error="errorMessage"
  )
  FunnelSettings(
    :settings="settings"
    @save="save"
    :isSaving="isSaving"
    :displayAdvanced="!!this.userIsAdvanced"
    :enableMultilanguage="enableMultilanguage"
    :canViewAuditTrail="!!this.canViewAuditTrail"
    :enableCustomDomain="enableCustomDomain"
    )
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FunnelSettings from '@v/settings/application/funnel/FunnelSettings.vue'
import tryCall from '@v/mixins/tryCall.js'

export default {
  name: 'FunnelSettingsWrapper',
  components: { FunnelSettings },
  inject: ['funnelSettingsService'],
  props: {
    userIsAdvanced: Boolean,
    enableMultilanguage: Boolean, // feature flag
    canViewAuditTrail: Boolean,
  },
  mixins: [tryCall],
  data() {
    return {
      settings: null,
      savePending: false,
      isFetching: true,
      error: '',
      errorMessage: '',
      isSaving: false,
    }
  },
  computed: {
    ...mapState('imagePicker', ['file', 'removeExistingFile', 'fileTwo', 'removeExistingFileTwo']),
    ...mapGetters('briqState', ['enabledFeatures']),
    enableCustomDomain() {
      return this.enabledFeatures?.includes('EnableVanityDomains')
    },
  },
  methods: {
    async getFunnelSettingsData() {
      this.isFetching = true
      try {
        this.settings = await this.funnelSettingsService.fetchFunnelSettings()
      } catch (e) {
        this.error = e
        this.$logError(e)
        const message = 'There was a problem: ' + this.error.message
        this.errorMessage = message
        this.$notifyError(message)
      }
      this.isFetching = false
    },
    async save() {
      if (this.isSaving) this.$logWarning('Save already in progress')
      this.isSaving = true
      const { success, data, error } = await this.funnelSettingsService.save({
        logoFile: this.file,
        faviconFile: this.fileTwo,
        settings: this.settings,
        removeLogo: this.removeExistingFile,
        removeFavicon: this.removeExistingFileTwo,
        enableMultilanguage: this.enableMultilanguage,
      })
      if (success) {
        this.$notifySuccess('Settings saved')
      } else {
        this.$logError(error)
        this.$notifyError('Error while trying to save')
      }
      this.isSaving = false
    },
  },
  async beforeMount() {
    await this.getFunnelSettingsData()
  },
}
</script>
